<style lang="scss" scoped>
  .modal-body,
  .modal-dialog {
    width: 462px;
  }

  .cancel {
    text-decoration: underline;
    color: #130f19;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    color: var(--salesflow-font-gray);
  }
</style>

<template>
  <BModal
    id="invite-user-modal"
    ref="invite-user-modal"
    modal-class="modal-no-header-no-footer"
    hide-header="hide-header"
    hide-footer="hide-footer"
  >
    <template slot="default">
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="$refs['invite-user-modal'].hide()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title align-items-center text-center">
        {{ __('Convidar usuário') }}
      </h4>
      <div class="pt-0 pb-5" style="padding-left: 60px !important; padding-right: 60px !important">
        <div class="form-group">
          <label>{{ __('E-mail') }}</label>
          <input
            class="form-control"
            id="autofocus"
            type="email"
            v-model="email"
            required=""
            autofocus=""
            :placeholder="__('Digite aqui')"
          >
          <p
            class="text-danger"
            v-if="errors.email"
          >
            {{ errors.email }}
          </p>
        </div>
        <div class="form-group">
          <label>{{ __('Grupo') }}</label>
          <select
            class="form-control"
            v-model="role"
          >
            <option
              value=""
            >{{ __('Selecione') }}</option>
            <option
              v-for="role in roles"
              :value="role.id"
            >{{ role.name }}</option>
          </select>
          <p
            class="text-danger"
            v-if="errors.role"
          >
            {{ errors.role }}
          </p>
        </div>
      </div>
      <div class="form-group text-center">
        <BButton
          class="align-items-center salesflow-btn-save"
          variant="primary"
          type="submit"
          @click="invite()"
          :disabled="disabled"
        >
          <span v-if="!inviting">{{ __('Convidar') }}</span><span v-else><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Convidando...') }}</span>
        </BButton>
        <div class="cancel mt-4">
          <a
            href="#"
            @click.prevent="close"
          >{{ __('Cancelar') }}</a>
        </div>
      </div>
    </template>
  </BModal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';

export default {
  components: {
    BModal,
    BButton,
  },

  created () {
    this.getRoles();

    Bus.$on('inviteUserButtonToggled', (reload) => {
      if (reload) {
        this.reload = true;
      }

      this.open();
    });
  },

  data () {
    return {
      email: null,
      role: '',
      roles: [],
      inviting: false,
      errors: {
        email: false,
        role: false,
      },
    };
  },

  computed: {
    disabled () {
      return this.inviting || this.email === null || this.role === null;
    },
  },

  methods: {
    open () {
      this.$refs['invite-user-modal'].show();
    },

    getRoles () {
      this.$http.get('/role?ajax=true')
        .then((response) => {
          this.roles = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },

    close () {
      this.email = null;
      this.role = null;

      this.$refs['invite-user-modal'].hide();
    },

    invite () {
      this.inviting = true;

      const data = {
        email: this.email,
        role: this.role,
      };

      this.$http.post('/user/invite', data)
        .then((response) => {
          this.close();

          Alert.info(this.__('Usuário convidado!'));

          if (this.reload) {
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        })
        .catch((response) => {
          this.errors = response.data;

          if (response.status != 422) {
            Alert.error(this.__('Erro ao enviar convite.'));
          }
        }).finally((response) => {
          this.inviting = false;
        });
    },
  },
};
</script>
